<template>
  <div>
    <div class="about">
      <div :class="'header-image default-header-' + rand">
        <SubTopNav v-if="title" :title="title" />
      </div>

      <div class="page-content animated fadeInUp item-grid">
        <div v-if="contentImages">
          <img :src="baseDomain + contentImages" v-if="contentImages" />
        </div>
        <div v-html="contentBody"></div>

        <div class="item-group-downloads" v-if="download && download.url && download.description">
          <div class="group-item">
            <a :href="baseDomain + download.url" target="_blank">
              <div class="name">
                <div>
                  <i class="fas fa-download"></i>&nbsp;&nbsp;<strong>{{ download.description }}</strong>
                </div>
              </div>
            </a>
          </div>
        </div>
        <!-- <div  class="content-body item animated fadeInUp" v-for="(item, index) in contentBody" :key="index">
	    			<div class="body-row">
	    				<div class="body-image" v-if="contentImages && contentImages[index]">
	    					<img :src="contentImages[index].url">
	    				</div>
	    				<div v-if="index == 0">
			    			<h3>{{ tagline }}</h3>
			    			<div v-html="item.value"></div>
			    		</div>
			    		<div v-else v-html="item.value"></div>
		    			
		    		</div>
	    			
	    		</div> -->
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import { mapState } from "vuex"
import SubTopNav from "@/components/SubTopNav.vue"
import { RepositoryFactory } from "@/repositories/RepositoryFactory"
const ContentRepository = RepositoryFactory.get("content")

export default {
  name: "opportunity",
  components: {
    SubTopNav,
  },
  data: function() {
    return {
      content: null,
      image: null,
      featuredImage: null,
      contentImages: null,
      contentBody: null,
      title: null,
      rand: 1,
      tagline: null,
      siblings: [],
      download: null,
    }
  },
  methods: {
    async getNodeWithAlias(alias) {
      // var id = "2"
      const { data } = await ContentRepository.getNodeWithAlias(alias)

      this.title = data[0].title
      this.tagline = data[0].body.summary
      this.contentImages = data[0].field_content_image_s_
      this.contentBody = data[0].body
      var download = data[0].field_download_s_

      if (download) {
        var downloads = download.split("||")
        this.download = {
          description: downloads[0],
          url: downloads[1],
        }
      }

      // console.log('download', this.download)
      // if (this.download != null){
      // 	this.download = JSON.parse(this.download)
      // 	console.log('download parse', this.download)
      // }

      // console.log('downloads', this.downloads)

      // this.getSiblings()
    },
    // getSiblings(){
    // 	var navigation = this.$session.get('navigation')
    // 	var pageTitle = this.title.toLowerCase()
    // 	if (navigation && navigation.length){
    // 		var menuItemArr = navigation.filter(function (item){
    //         return item.name.toLowerCase() == pageTitle
    //       })

    //       var menuItem = menuItemArr[0]
    //       var menuParent = menuItem.parent

    //       if (menuParent){
    //       	var siblingsArr = navigation.filter(function (item){
    //       		return (item.parent == menuParent) && (item.name.toLowerCase() != pageTitle)
    //       	})

    //       	this.siblings = siblingsArr

    //       }

    //       // console.log('sub expertise', this.subExpertise)
    // 	}
    // }
  },
  mounted() {
    var alias = this.$route.params.alias
    // console.log('alias', alias)
    if (alias) {
      this.getNodeWithAlias(alias)
    }

    this.rand = Math.floor(Math.random() * 8) + 1
  },
  computed: {
    ...mapState(["baseDomain"]),
  },
}
</script>
<style scoped>
.page-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  xgrid-row: 1;
  grid-gap: 25px;
}

.item-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 25px;
}

.page-grid .item {
  xbackground: #ccc;
  xpadding: 10px;
}

.page-grid .item:nth-child(1) {
  xborder: 1px solid red;
  grid-column: 1 / 4;
}

.page-grid .item:nth-child(1) .body-row {
  display: grid;
  grid-template-columns: 1fr 2fr;
  background: #f2f2f2;
  xborder: 10px solid #e1e1e1;
  xpadding: 25px;
  grid-gap: 25px;
  margin-top: 25px;
  xborder-radius: 0px 0px 85px 0px;
}

.page-grid .item:nth-child(1) .body-row div:nth-child(1) {
  background: #ccc;
  padding: 25px;
}

.page-grid .item:nth-child(1) .body-row div:nth-child(2) h3 {
  margin-top: 55px;
}

.page-grid .item:nth-child(1) .body-row div:nth-child(2) {
  padding: 25px;
}

.page-grid img {
  max-width: 100%;
}

.page-grid .item:nth-child(2) {
  border-top: 5px solid #cc0000;
  padding-top: 20px;
  margin-top: 20px;
}

.page-grid .item:nth-child(3) {
  border-top: 5px solid #ffcc33;
  padding-top: 20px;
  margin-top: 20px;
}

.page-grid .item:nth-child(4) {
  border-top: 5px solid #339900;
  padding-top: 20px;
  margin-top: 20px;
}

.page-content {
  text-align: left;
  xmargin-bottom: 30px;
}

.image-break {
  height: 300px;
  xbackground: #ccc;
  margin-top: 35px;
  margin-bottom: 35px;
}

.image-box {
  height: 300px;
  top: 0;
  left: 0;
  filter: grayscale(100%);
  xopacity: 0.3;
}

.image-text {
  margin-top: -300px;
  z-index: 50;
  position: relative;
}

.image-text a {
  color: #fff;
}

.image-text .container div {
  background: rgba(255, 102, 0, 0.8);
  color: #fff;
  padding: 105px 50px 50px 50px;
  float: left;
  width: 50%;
  height: 300px;
}

.page-content .content-body:nth-child(2n) .image-text .container div {
  float: right;
  background: rgba(102, 153, 51, 0.8);
}

.body-row {
  xpadding: 25px;
}

.page-content img {
  max-width: 100%;
  margin-bottom: 25px;
}

.group-item {
  xpadding: 25px;
  box-shadow: 3px 3px 5px #ccc;
  background-size: 25px;
  cursor: pointer;
  border-radius: 0 0 25px 0;
  margin-bottom: 40px;
}

.group-item a:hover {
  text-decoration: none;
  color: #fff;
}

.group-item a {
  color: #00733c;
}

.group-item:hover {
  color: #fff;
  background: #00733c;
}

.group-item:hover a {
  background: #00733c;
  color: #fff;
}

.group-item .name {
  padding: 25px;
}

@media (max-width: 768px) {
  .item-grid {
    grid-template-columns: 1fr;
  }
}
</style>
